<template>
  <div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Guide',
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
    membersGuideKey: function () {
      return 'members-guide.' + this.user.id;
    },
    matchGameGuideKey: function () {
      return 'match-game-guide.' + this.user.id;
    },
    currentRouteName() {
      return this.$route.name;
    }
  },
  watch: {
    $route(to, from) {
      this.init();
    }
  },
  methods: {
    showMembersGuide() {
      let vm = this;
      let selectors = ['#menu-members', '#menu-chat'];
      if (window.innerWidth < 600) {
        selectors = ['#menu-mobile-members', '#menu-mobile-chat'];
      }

      introJs().setOptions({
        steps: [{
          element: document.querySelector(selectors[0]),
          intro: vm.trans.get('guide.first'),
        }]
      }).start().onexit(() => {
        step2();
      });

      function step2() {
        window.setTimeout(() => {
          window.scrollTo({
            top: 0,
            left: 0,
          });
          introJs().setOptions({
            steps: [{
              element: document.querySelector(selectors[1]),
              intro: vm.trans.get('guide.second'),
            }]
          }).start();
        }, 500);
      }
    },
    showMatchGameGuide() {
      let vm = this;
      introJs().setOptions({
        steps: [{
          element: document.querySelector('.match-game__switch'),
          intro: vm.trans.get('guide.fourth'),
        }]
      }).start();

      introJs().setOptions({
        steps: [{
          element: document.querySelector('.match-game__switch'),
          intro: vm.trans.get('guide.third'),
        }]
      }).start().onexit(() => {
        step2();
      });

      function step2() {
        window.setTimeout(() => {
          window.scrollTo({
            top: 0,
            left: 0,
          });
          introJs().setOptions({
            steps: [{
              element: document.querySelector('.button__superlike'),
              intro: vm.trans.get('guide.fourth'),
            }]
          }).start();
        }, 500);
      }
    },
    init() {
      let vm = this;
      setTimeout(() => {
        if (
          !this.user
          || this.user.guide
        ) {
          return false;
        }

        if (
          (vm.currentRouteName === 'members')
          && !window.localStorage.getItem(vm.membersGuideKey)
        ) {
          vm.showMembersGuide();
          window.localStorage.setItem(vm.membersGuideKey, 'OK');
        }

        if (
          (vm.currentRouteName === 'match_game')
          && !window.localStorage.getItem(vm.matchGameGuideKey)
        ) {
          let element = document.querySelector('.button__superlike');

          if (element && element.style.display !== 'none') {
            vm.showMatchGameGuide();

            window.localStorage.setItem(vm.matchGameGuideKey, 'OK');
            axios.post(zRoute('ajax.guides.store'));
          }
        }
      }, 1000);
    },
  },
  mounted() {
    let vm = this;

    /*
     * Disable guide on page
     */
    // vm.$eventHub.$on('UserLoaded', function () {
    //     vm.init();
    // });
    //
    // vm.$eventHub.$on('NoUserMediaCardHide', function () {
    //     vm.init();
    // });
  },
};
</script>
